export default __webpack_public_path__ + "static/media/project-icon.f913b5c4.svg";